<template>
  <b-card no-body>
    <b-table
      :tbody-tr-class="rowClass"
      :fields="fields"
      :items="balance ? [{}]: []"
      class="table-bordered"
    >
      <template #thead-top="">
        <b-tr>
          <b-th
            colspan="5"
            class="text-center"
            style="background: none"
          >
            {{ $t("Quota available in the organization for {year}", { year: quoteDistribution.period.admission_year }) + '( Balance Innavatsiya)' }}
          </b-th>
        </b-tr>
        <b-tr>
          <b-th
            colspan="2"
            class="text-center"
            style="background: none"
          >
            {{ $langName(getQuoteOrgType(quoteOrgTypeITM).name) }}
          </b-th>
          <b-th
            colspan="2"
            class="text-center"
            style="background: none"
          >
            {{ $langName(getQuoteOrgType(quoteOrgTypeOTM).name) }}
          </b-th>
        </b-tr>
      </template>
      <template #head()="data">
        {{ getHead(data) }}
      </template>
      <template #cell()="data">
        {{ getValueOfItemInBalance(data.field.data) }}
      </template>
    </b-table>
  </b-card>
</template>

<script>
import {
  // eslint-disable-next-line no-unused-vars
  BCard, BCol, BFormInput, BLink, BRow, BSpinner, BTable, BTh, BTr,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import quoteDistributionModule from '@/store/quote-distribution'
import permission from '@/views/pages/quote-distribution-innovation/permission'
import { myOrganization } from '@/auth/utils'

export default {
  name: 'InnovationBalance',
  components: {
    BCard,
    BTable,
    BTr,
    BTh,
  },
  computed: {
    balance() {
      return this.$store.state[this.MODULE_NAME].balance
    },
    quoteDistribution() {
      return this.$store.state[this.MODULE_NAME].quoteDistribution
    },
  },
  created() {
    this.refetchData()
  },
  methods: {
    refetchData() {
      this.loadBalance()
    },
    loadBalance() {
      this.$store.dispatch(`${this.MODULE_NAME}/getBalance`, { period_id: this.quoteDistribution.period.id, org_id: myOrganization().id })
    },
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](id)
    },
    getHead(head) {
      const col = head.label
      if (Number(col) >= 100 && Number(col) <= 700) {
        return this.$langName(this.getDcType(Number(col)).name)
      }
      return this.$t(col)
    },
    rowClass(item, type) {
      if (item && type === 'row') {
        if (item.type === 'ministry') {
          return 'text-bold font-weight-bold bg-light'
        }
        return 'text-secondary'
      }
      return null
    },
    getQuoteOrgType(id) {
      return this.$store.getters['staticModule/getQuoteOrgType'](id)
    },

    getValueOfItemInBalance(data) {
      let res = 0
      this.balance.forEach(orgTypes => {
        if (orgTypes.org_type === data.org_type) {
          orgTypes.sum.forEach(item => {
            if (item.dc_type === data.dc_type) {
              res += item.sum
            }
          })
        }
      })
      return res
    },
  },
  setup() {
    const {
      DSc, PhD, traineeResearcher,
      quoteOrgTypeOTM, quoteOrgTypeITM, quoteOrgTypeCommon,
      totalQuoteTypeRequest,
    } = store.state.staticModule
    const fieldsAccepted = [
      { key: 'index', label: '#' },
      { key: 'name', label: 'Organization' },
    ]
    const fields = [
      { key: 'dc_itm', label: `${DSc}`, data: { org_type: quoteOrgTypeITM, dc_type: DSc } },
      { key: 'phd_itm', label: `${PhD}`, data: { org_type: quoteOrgTypeITM, dc_type: PhD } },
      { key: 'dc_otm', label: `${DSc}`, data: { org_type: quoteOrgTypeOTM, dc_type: DSc } },
      { key: 'phd_otm', label: `${PhD}`, data: { org_type: quoteOrgTypeOTM, dc_type: PhD } },
      { key: 'trainee_researcher', label: `${traineeResearcher}`, data: { org_type: quoteOrgTypeCommon, dc_type: traineeResearcher } },
    ]
    const searchQuery = ''
    const MODULE_NAME = 'quoteDistribution'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, quoteDistributionModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })
    return {
      MODULE_NAME,
      DSc,
      PhD,
      traineeResearcher,
      fieldsAccepted,
      fields,
      quoteOrgTypeITM,
      quoteOrgTypeOTM,
      quoteOrgTypeCommon,
      totalQuoteTypeRequest,
      ...permission(),
      searchQuery,
    }
  },
}
</script>

<style scoped>

</style>
